import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: [],
    loading: false
  },
  getters: {
    details: state => state.details,
    loading: state => state.loading
  },
  actions: {
    fetchSingle({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("MiddlewareOfAccessToTadbir/api/OrdersQuery/" + id)
          .then(r => {
            commit("setDetails", r.data);
            commit("setLoading", false);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    }
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    }
  }
};
